import Div from "@jumbo/shared/Div";
import { Button, InputAdornment, TextField, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getAllFabricColor } from "app/redux/actions/masterAction";
import ListFabricColorTable from "./fabricColorTable";

export default function ListFabricColor() {
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));

  const handleSearch = (value) => {
    setPage(1);
    dispatch(getAllFabricColor(value, 1));
  };
  useEffect(() => {
    dispatch(getAllFabricColor());
  }, []);
  return (
    <Div sx={{ mt: -4 }}>
      <Typography variant="h1">Fabric Color Master</Typography>
      <Div
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <TextField
          size="small"
          id="search"
          type="search"
          label="Search"
          value={searchTerm}
          onChange={(e) => {
            setPage(1);
            setSearchTerm(e.target.value);
            handleSearch(e.target.value);
          }}
          sx={{ width: 300, mb: 5, mt: 4 }}
          InputProps={{
            endAdornment: (
              <Div sx={{ cursor: "pointer" }} onClick={handleSearch}>
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              </Div>
            ),
          }}
        />
        {permissions?.fabric_color_master_create == true && (
          <Div>
            <Button
              variant="contained"
              sx={{ p: 1, pl: 4, pr: 4 }}
              onClick={() => navigate("/master/fabric-color/add")}
            >
              Add Fabric Color
            </Button>
          </Div>
        )}
      </Div>
      <ListFabricColorTable
        searchTerm={searchTerm}
        setPage={setPage}
        page={page}
      />
    </Div>
  );
}
